import { vivochaContainer } from 'components/vivocha/vivocha.helpers';
import { Fragment } from 'react';
import { Translate } from 'react-localize-redux';
import { useIsAtLeastDesktopBreakpoint } from 'utils/hooks/media-queries';
import TermsAndConditionsComponent from './partials/SEU/TermsAndConditions/TermsAndConditions.component';
import {
  FooterButton,
  FooterContainer,
  FooterSubTitle,
  FooterTitle,
} from './style/Footer.style';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type FooterProps = {
  footerCtaTrackingClick?: () => void;
  isInsideDrawer?: boolean;
};

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/
export default function Footer({
  footerCtaTrackingClick,
  isInsideDrawer,
}: FooterProps) {
  const isAtLeastDesktopBreakpoint = useIsAtLeastDesktopBreakpoint();

  const footerCtaProps = {
    className: 'vvc-hc-button',
    onClick: () => {
      vivochaContainer({ show: true });
      if (footerCtaTrackingClick) footerCtaTrackingClick();
    },
  };

  return (
    <Fragment>
      <FooterContainer
        flexDirection={isAtLeastDesktopBreakpoint ? 'row' : 'column'}
        justify="space-between"
        align={isAtLeastDesktopBreakpoint ? 'center' : 'flex-start'}
        padding="16px"
      >
        <div>
          <FooterTitle>
            <Translate id="text.footer.title" />
          </FooterTitle>
          <FooterSubTitle>
            <Translate id="text.footer.subtitle" />
          </FooterSubTitle>
        </div>
        <div className="vvc-hc-button-container">
          <FooterButton {...footerCtaProps} variant="outline">
            <Translate id="lbl.footer.cta" />
          </FooterButton>
        </div>
      </FooterContainer>
      <TermsAndConditionsComponent isInsideDrawer={isInsideDrawer} />
    </Fragment>
  );
}
